// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.c11afe6dc',
  revision: 'c11afe6dc',
  branch: 'develop',
  date: 'Wed, 16 Sep 2026 14:54:42 GMT'
};